import React, { PropTypes } from 'react';
// Components
import MediaPartner from './MediaPartner';
import NoData from '../../layout/noData/NoData';

const propTypes = {
  medias: PropTypes.object.isRequired,
  locale: PropTypes.string,
};

const MediaPartnersBox = ({ locale, medias }) => {
  const list = medias.items
    ? (
      medias.items.map((media, i) => {
        return <MediaPartner key={i} media={media} locale={locale} />;
      })
    )
    : <NoData />;

  return (
    <ui id="medias" className="sponsors overflow list">
      {list}
    </ui>
  );
};

MediaPartnersBox.propTypes = propTypes;

export default MediaPartnersBox;



/** WEBPACK FOOTER **
 ** ./src/components/screens/mediaPartners/MediaPartnersBox.js
 **/